webpackJsonp([4],{

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_show_vue__ = __webpack_require__(777);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c29fd0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_vue__ = __webpack_require__(820);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c29fd0a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 754:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__request__ = __webpack_require__(69);


var resource = 'chat-groups';
var show = function show(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/' + id);
};
var get = function get() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get('' + resource, { params: params });
};
var getBookmarks = function getBookmarks(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/bookmarks', { params: params });
};
var store = function store(data) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post('' + resource, data);
};
var get_messages = function get_messages(params) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].get(resource + '/' + params.id + '/messages', { params: params });
};
var store_messages = function store_messages(id, message) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/' + id + '/messages', message);
};
var read_message = function read_message(id) {
  return __WEBPACK_IMPORTED_MODULE_0__request__["a" /* default */].post(resource + '/' + id + '/read');
};

/* harmony default export */ __webpack_exports__["a"] = ({
  show: show,
  get: get,
  getBookmarks: getBookmarks,
  store: store,
  get_messages: get_messages,
  store_messages: store_messages,
  read_message: read_message
});

/***/ }),

/***/ 755:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    ok_text: { type: String, default: 'はい' },
    cancel_text: { type: String, default: 'キャンセル' },
    type: { type: String, default: 'success' },
    title: { type: String, required: false, default: '' },
    content: { type: String, required: false, default: '' }
  },
  methods: {
    ok: function ok() {
      this.$emit('ok');
    },
    cancel: function cancel() {
      this.$emit('cancel');
    }
  }
});

/***/ }),

/***/ 759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(755);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbb5546_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__(760);
var normalizeComponent = __webpack_require__(105)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fbb5546_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 760:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_wrapper"},[_c('div',{staticClass:"modal",class:_vm.type},[_c('div',{staticClass:"header"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c('span',{staticClass:"close_button",on:{"click":_vm.cancel}})]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content mb-2",domProps:{"innerHTML":_vm._s(_vm.content)}}),_vm._v(" "),_c('div',{staticClass:"buttons mb-2"},[_c('span',{staticClass:"button button_small button_rounded bordered",class:{tree_green: _vm.type === 'success'},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.ok_text))]),_vm._v(" "),_c('span',{staticClass:"button button_small button_rounded bordered",class:{tree_green: _vm.type === 'success'},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancel_text))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 767:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeMessageDataForFirebase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeChatGroupDataForFirebase; });
/* unused harmony export checkResponseStatus */
/* unused harmony export isCurrentEmployeeApprove */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);


var makeMessageDataForFirebase = function makeMessageDataForFirebase(_ref) {
  var message = _ref.message;

  return {
    employee_code: message.employee_code,
    chat_group_id: message.chat_group_id,
    display_name: message.display_name,
    content: message.content,
    has_attachment: message.has_attachment,
    attachment: message.attachment,
    attachment_url: message.attachment_url,
    favorite_display_names: '',
    created_at: message.created_at,
    updated_at: message.updated_at,
    deleted_at: message.deleted_at ? message.deleted_at : false,
    is_ng: message.is_ng,
    read_count: message.read_count
  };
};

var makeChatGroupDataForFirebase = function makeChatGroupDataForFirebase(_ref2) {
  var chatGroup = _ref2.chatGroup,
      lastMessage = _ref2.lastMessage;

  return {
    company_code: chatGroup.company_code,
    market_code: chatGroup.market_code,
    institution_code: chatGroup.institution_code,
    last_message: lastMessage,
    last_timestamp: Date.now(),
    total: chatGroup.total_messages
  };
};

var checkResponseStatus = function checkResponseStatus(response) {
  return response && response.status === 200;
};

var isCurrentEmployeeApprove = function isCurrentEmployeeApprove(finePlay) {
  var employeeCode = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].auth.user().employee_code;
  var myIndexOfHistory = finePlay.fine_play_histories.findIndex(function (n) {
    return n.recipient_employee_code === employeeCode;
  });
  if (myIndexOfHistory > 0) {
    var statusOfPreEmployee = finePlay.fine_play_histories[myIndexOfHistory - 1].status;
    var statusOfMyEmployee = finePlay.fine_play_histories[myIndexOfHistory].status;
    if (statusOfPreEmployee === 'preapproval') {
      return false;
    }
    if (statusOfMyEmployee !== 'preapproval') {
      return false;
    }
  }
  return true;
};

/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_chat_group__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_institution__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_modal__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_9__components_modal__["a" /* default */]
  },
  data: function data() {
    return {
      institution: {},
      chatGroups: [],
      modal: {
        show: '',
        title: '',
        content: ''
      },
      subscribeChatGroup: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])({
    setLinks: 'navigator/setLinks',
    getParticipateChatGroups: 'institution/getParticipateChatGroups',
    setFineplay: 'navigator/setFineplay',
    clearUnreadMessages: 'institution/clearUnreadMessages'
  }), {
    handleClickChatGroup: function handleClickChatGroup(chatGroup) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var snapshot, snapshotInstitution;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* default */].getChatGroup(chatGroup.id);

              case 2:
                snapshot = _context.sent;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* default */].getInstitution(_this.institution.institution_code);

              case 5:
                snapshotInstitution = _context.sent;

                if (snapshot.exists()) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* default */].storeChatGroup(chatGroup.id, Object(__WEBPACK_IMPORTED_MODULE_8__helpers__["a" /* makeChatGroupDataForFirebase */])({ chatGroup: chatGroup, lastMessage: '' }));

              case 9:
                if (snapshotInstitution.exists()) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_7__firebase__["b" /* default */].storeInstitution(_this.institution.institution_code, { total: _this.institution.total_unread_messages });

              case 12:

                _this.$router.push({ name: 'chat', params: { chatGroupId: chatGroup.id } });

                _this.clearUnreadMessages({
                  institutionCode: _this.institution.institution_code,
                  total: chatGroup.total_unread_messages
                });

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setNavigatorLinks: function setNavigatorLinks() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_6__api_institution__["a" /* default */].show(_this2.$route.params.institutionCode);

              case 2:
                res = _context2.sent;

                _this2.institution = res.data.data;
                _this2.setLinks([{ title: _this2.institution.abbreviated_name_kanji, route: { name: 'home' } }]);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    paginate: function paginate($state) {
      var _this3 = this;

      setTimeout(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_5__api_chat_group__["a" /* default */].get({
                  institution_code: _this3.$route.params.institutionCode,
                  offset: _this3.chatGroups.length
                });

              case 2:
                res = _context3.sent;

                _this3.chatGroups = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this3.chatGroups), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(res.data.data));
                _this3.chatGroups = __WEBPACK_IMPORTED_MODULE_10_lodash___default.a.sortBy(_this3.chatGroups, ['company_code', 'maker_product_code']);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      })));
    },
    showParticipants: function showParticipants(chatGroup) {
      this.modal.show = true;
      this.modal.title = chatGroup.company.short_name + ' ' + chatGroup.market_code;
      var content = '';
      chatGroup.employees.forEach(function (n) {
        content += n.company_code + ' ' + n.name_kanji + '<br>';
      });
      this.modal.content = content;
    }
  }),
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.setNavigatorLinks();

            case 2:
              _this4.setFineplay(false);

              _this4.subscribeChatGroup = __WEBPACK_IMPORTED_MODULE_7__firebase__["a" /* db */].ref('chat_groups');
              _this4.subscribeChatGroup.on('child_changed', function (data) {
                var index = _this4.chatGroups.findIndex(function (n) {
                  return n.id === parseInt(data.key);
                });
                if (index !== -1) {
                  if (data.val().total > _this4.chatGroups[index].total_messages) {
                    _this4.chatGroups[index].total_unread_messages = _this4.chatGroups[index].total_unread_messages + 1;
                    _this4.chatGroups[index].total_messages = _this4.chatGroups[index].total_messages + 1;
                  }
                }
              });

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    this.subscribeChatGroup.off();
  }
});

/***/ }),

/***/ 820:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"items_list white"},[_vm._l((_vm.chatGroups),function(chatGroup){return _c('div',{key:chatGroup.id,staticClass:"item",on:{"click":function($event){return _vm.handleClickChatGroup(chatGroup)}}},[_c('span',{staticClass:"text"},[_vm._v("\n              "+_vm._s(chatGroup.company.short_name)),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(chatGroup.maker_product_name))])]),_vm._v(" "),(chatGroup.total_unread_messages > 0)?_c('span',{staticClass:"badge chat_group"},[_vm._v("\n                "+_vm._s(chatGroup.total_unread_messages)+"\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item_button button button_small button_rounded bordered deep_blue",on:{"click":function($event){$event.stopPropagation();return _vm.showParticipants(chatGroup)}}},[_c('span',{staticClass:"icon icon_users_group"}),_vm._v(" メンバー\n            ")])])}),_vm._v(" "),_c('infinite-loading',{on:{"infinite":_vm.paginate}},[_c('div',{attrs:{"slot":"spinner"},slot:"spinner"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-more"},slot:"no-more"}),_vm._v(" "),_c('div',{attrs:{"slot":"no-results"},slot:"no-results"})])],2),_vm._v(" "),_c('Modal',{directives:[{name:"show",rawName:"v-show",value:(_vm.modal.show),expression:"modal.show"}],attrs:{"title":_vm.modal.title,"content":_vm.modal.content,"type":"chat-group"},on:{"cancel":function($event){_vm.modal.show = false}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/4.5348f68fe4d09c6ba951.js